/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateAccount = /* GraphQL */ `
  subscription OnCreateAccount($owner: String) {
    onCreateAccount(owner: $owner) {
      id
      owner
      groups
      active
      status
      businessName
      displayName
      accountNumber
      externalId
      externalStatus
      accountType
      defaultBillToAccountId
      lotNumberPrefix
      color
      defaultWeightUOM
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      creditLimit
      overLimit
      overDue
      einNumber
      skipInvoice
      email
      phone
      fax
      website
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      billingAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      contacts {
        name
        email
        phone
        description
      }
      billingContacts {
        name
        email
        phone
        description
      }
      billingEmail
      invoiceSubject
      invoiceAttachments
      invoiceCustomFields {
        id
        name
        type
        display
        required
      }
      addressState
      reloadYardId
      inboundCustomFields {
        id
        name
        type
        display
        required
      }
      inboundInstructions
      secondaryReview
      inboundSkipSignature
      inboundPhotos
      podEmail
      podPhotos
      podAttachments
      podSubject
      inboundAdviceInputs
      inboundEventTypeId
      lotType
      lotNumberOverride
      fifoLotNumber
      carlotLotNumber
      verifyInboundRailCar
      trackInboundSeals
      requireDefaultZone
      outboundCustomFields {
        id
        name
        type
        display
        required
      }
      outboundInstructions
      posEmail
      posPhotos
      posAttachments
      posSubject
      outboundSkipSignature
      outboundPhotos
      outboundReview
      outboundAdviceInputs
      outboundEventTypeId
      generatePickupNumber
      mustTarp
      verifyOutboundRailCar
      trackOutboundSeals
      inventoryCustomFields {
        id
        name
        type
        display
        required
      }
      inventoryPrimaryField
      inventoryPhotos
      trackInventorySeals
      isBarcodeRequired
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      services {
        items {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAccount = /* GraphQL */ `
  subscription OnUpdateAccount($owner: String) {
    onUpdateAccount(owner: $owner) {
      id
      owner
      groups
      active
      status
      businessName
      displayName
      accountNumber
      externalId
      externalStatus
      accountType
      defaultBillToAccountId
      lotNumberPrefix
      color
      defaultWeightUOM
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      creditLimit
      overLimit
      overDue
      einNumber
      skipInvoice
      email
      phone
      fax
      website
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      billingAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      contacts {
        name
        email
        phone
        description
      }
      billingContacts {
        name
        email
        phone
        description
      }
      billingEmail
      invoiceSubject
      invoiceAttachments
      invoiceCustomFields {
        id
        name
        type
        display
        required
      }
      addressState
      reloadYardId
      inboundCustomFields {
        id
        name
        type
        display
        required
      }
      inboundInstructions
      secondaryReview
      inboundSkipSignature
      inboundPhotos
      podEmail
      podPhotos
      podAttachments
      podSubject
      inboundAdviceInputs
      inboundEventTypeId
      lotType
      lotNumberOverride
      fifoLotNumber
      carlotLotNumber
      verifyInboundRailCar
      trackInboundSeals
      requireDefaultZone
      outboundCustomFields {
        id
        name
        type
        display
        required
      }
      outboundInstructions
      posEmail
      posPhotos
      posAttachments
      posSubject
      outboundSkipSignature
      outboundPhotos
      outboundReview
      outboundAdviceInputs
      outboundEventTypeId
      generatePickupNumber
      mustTarp
      verifyOutboundRailCar
      trackOutboundSeals
      inventoryCustomFields {
        id
        name
        type
        display
        required
      }
      inventoryPrimaryField
      inventoryPhotos
      trackInventorySeals
      isBarcodeRequired
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      services {
        items {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAccount = /* GraphQL */ `
  subscription OnDeleteAccount($owner: String) {
    onDeleteAccount(owner: $owner) {
      id
      owner
      groups
      active
      status
      businessName
      displayName
      accountNumber
      externalId
      externalStatus
      accountType
      defaultBillToAccountId
      lotNumberPrefix
      color
      defaultWeightUOM
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      creditLimit
      overLimit
      overDue
      einNumber
      skipInvoice
      email
      phone
      fax
      website
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      billingAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      contacts {
        name
        email
        phone
        description
      }
      billingContacts {
        name
        email
        phone
        description
      }
      billingEmail
      invoiceSubject
      invoiceAttachments
      invoiceCustomFields {
        id
        name
        type
        display
        required
      }
      addressState
      reloadYardId
      inboundCustomFields {
        id
        name
        type
        display
        required
      }
      inboundInstructions
      secondaryReview
      inboundSkipSignature
      inboundPhotos
      podEmail
      podPhotos
      podAttachments
      podSubject
      inboundAdviceInputs
      inboundEventTypeId
      lotType
      lotNumberOverride
      fifoLotNumber
      carlotLotNumber
      verifyInboundRailCar
      trackInboundSeals
      requireDefaultZone
      outboundCustomFields {
        id
        name
        type
        display
        required
      }
      outboundInstructions
      posEmail
      posPhotos
      posAttachments
      posSubject
      outboundSkipSignature
      outboundPhotos
      outboundReview
      outboundAdviceInputs
      outboundEventTypeId
      generatePickupNumber
      mustTarp
      verifyOutboundRailCar
      trackOutboundSeals
      inventoryCustomFields {
        id
        name
        type
        display
        required
      }
      inventoryPrimaryField
      inventoryPhotos
      trackInventorySeals
      isBarcodeRequired
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      services {
        items {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAisle = /* GraphQL */ `
  subscription OnCreateAisle($owner: String) {
    onCreateAisle(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      locations {
        items {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        nextToken
      }
      bays
      levels
      positions
      totalLocations
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      capacityUsed
      length
      width
      sortKey
      topDownPickOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAisle = /* GraphQL */ `
  subscription OnUpdateAisle($owner: String) {
    onUpdateAisle(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      locations {
        items {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        nextToken
      }
      bays
      levels
      positions
      totalLocations
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      capacityUsed
      length
      width
      sortKey
      topDownPickOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAisle = /* GraphQL */ `
  subscription OnDeleteAisle($owner: String) {
    onDeleteAisle(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      locations {
        items {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        nextToken
      }
      bays
      levels
      positions
      totalLocations
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      capacityUsed
      length
      width
      sortKey
      topDownPickOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAnnouncement = /* GraphQL */ `
  subscription OnCreateAnnouncement {
    onCreateAnnouncement {
      id
      active
      activatedAt
      message
      urgency
      forceRefresh
      link
      tenantId
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAnnouncement = /* GraphQL */ `
  subscription OnUpdateAnnouncement {
    onUpdateAnnouncement {
      id
      active
      activatedAt
      message
      urgency
      forceRefresh
      link
      tenantId
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAnnouncement = /* GraphQL */ `
  subscription OnDeleteAnnouncement {
    onDeleteAnnouncement {
      id
      active
      activatedAt
      message
      urgency
      forceRefresh
      link
      tenantId
      createdAt
      updatedAt
    }
  }
`;
export const onCreateApiKey = /* GraphQL */ `
  subscription OnCreateApiKey {
    onCreateApiKey {
      id
      active
      groups
      reloadYardId
      name
      keyId
      createdBy
      deletedBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateApiKey = /* GraphQL */ `
  subscription OnUpdateApiKey {
    onUpdateApiKey {
      id
      active
      groups
      reloadYardId
      name
      keyId
      createdBy
      deletedBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteApiKey = /* GraphQL */ `
  subscription OnDeleteApiKey {
    onDeleteApiKey {
      id
      active
      groups
      reloadYardId
      name
      keyId
      createdBy
      deletedBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateArea = /* GraphQL */ `
  subscription OnCreateArea($owner: String) {
    onCreateArea(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      color
      areaType
      sortKey
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateArea = /* GraphQL */ `
  subscription OnUpdateArea($owner: String) {
    onUpdateArea(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      color
      areaType
      sortKey
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteArea = /* GraphQL */ `
  subscription OnDeleteArea($owner: String) {
    onDeleteArea(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      color
      areaType
      sortKey
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAssetType = /* GraphQL */ `
  subscription OnCreateAssetType($owner: String) {
    onCreateAssetType(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      maxConcurrentBookings
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAssetType = /* GraphQL */ `
  subscription OnUpdateAssetType($owner: String) {
    onUpdateAssetType(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      maxConcurrentBookings
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAssetType = /* GraphQL */ `
  subscription OnDeleteAssetType($owner: String) {
    onDeleteAssetType(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      maxConcurrentBookings
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAudit = /* GraphQL */ `
  subscription OnCreateAudit($owner: String) {
    onCreateAudit(owner: $owner) {
      id
      owner
      groups
      active
      status
      createdAt
      createDateTime
      notes
      reloadYardId
      processedItems
      processedLocations
      skippedItems
      nextItem
      nextItems {
        locationIdx
        owner
        name
      }
      direction
      accountId
      accountName
      assignedTo
      locations
      startDateTime
      endDateTime
      updatedAt
    }
  }
`;
export const onUpdateAudit = /* GraphQL */ `
  subscription OnUpdateAudit($owner: String) {
    onUpdateAudit(owner: $owner) {
      id
      owner
      groups
      active
      status
      createdAt
      createDateTime
      notes
      reloadYardId
      processedItems
      processedLocations
      skippedItems
      nextItem
      nextItems {
        locationIdx
        owner
        name
      }
      direction
      accountId
      accountName
      assignedTo
      locations
      startDateTime
      endDateTime
      updatedAt
    }
  }
`;
export const onDeleteAudit = /* GraphQL */ `
  subscription OnDeleteAudit($owner: String) {
    onDeleteAudit(owner: $owner) {
      id
      owner
      groups
      active
      status
      createdAt
      createDateTime
      notes
      reloadYardId
      processedItems
      processedLocations
      skippedItems
      nextItem
      nextItems {
        locationIdx
        owner
        name
      }
      direction
      accountId
      accountName
      assignedTo
      locations
      startDateTime
      endDateTime
      updatedAt
    }
  }
`;
export const onCreateBarcode = /* GraphQL */ `
  subscription OnCreateBarcode($owner: String) {
    onCreateBarcode(owner: $owner) {
      id
      owner
      groups
      active
      status
      value
      isScanned
      scannedIn
      scannedOut
      reloadYardId
      inboundShipmentId
      inventoryId
      locationId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateBarcode = /* GraphQL */ `
  subscription OnUpdateBarcode($owner: String) {
    onUpdateBarcode(owner: $owner) {
      id
      owner
      groups
      active
      status
      value
      isScanned
      scannedIn
      scannedOut
      reloadYardId
      inboundShipmentId
      inventoryId
      locationId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteBarcode = /* GraphQL */ `
  subscription OnDeleteBarcode($owner: String) {
    onDeleteBarcode(owner: $owner) {
      id
      owner
      groups
      active
      status
      value
      isScanned
      scannedIn
      scannedOut
      reloadYardId
      inboundShipmentId
      inventoryId
      locationId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCapability = /* GraphQL */ `
  subscription OnCreateCapability {
    onCreateCapability {
      id
      active
      sortKey
      name
      description
      requiresValue
      requiredValueLabel
      quantity
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCapability = /* GraphQL */ `
  subscription OnUpdateCapability {
    onUpdateCapability {
      id
      active
      sortKey
      name
      description
      requiresValue
      requiredValueLabel
      quantity
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCapability = /* GraphQL */ `
  subscription OnDeleteCapability {
    onDeleteCapability {
      id
      active
      sortKey
      name
      description
      requiresValue
      requiredValueLabel
      quantity
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCarrier = /* GraphQL */ `
  subscription OnCreateCarrier($owner: String) {
    onCreateCarrier(owner: $owner) {
      id
      owner
      active
      groups
      businessName
      dbaName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      companyId
      reloadYardId
      users {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCarrier = /* GraphQL */ `
  subscription OnUpdateCarrier($owner: String) {
    onUpdateCarrier(owner: $owner) {
      id
      owner
      active
      groups
      businessName
      dbaName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      companyId
      reloadYardId
      users {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCarrier = /* GraphQL */ `
  subscription OnDeleteCarrier($owner: String) {
    onDeleteCarrier(owner: $owner) {
      id
      owner
      active
      groups
      businessName
      dbaName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      companyId
      reloadYardId
      users {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCarrierCompany = /* GraphQL */ `
  subscription OnCreateCarrierCompany {
    onCreateCarrierCompany {
      id
      groups
      businessName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      yards {
        items {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCarrierCompany = /* GraphQL */ `
  subscription OnUpdateCarrierCompany {
    onUpdateCarrierCompany {
      id
      groups
      businessName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      yards {
        items {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCarrierCompany = /* GraphQL */ `
  subscription OnDeleteCarrierCompany {
    onDeleteCarrierCompany {
      id
      groups
      businessName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      yards {
        items {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCarrierUser = /* GraphQL */ `
  subscription OnCreateCarrierUser {
    onCreateCarrierUser {
      id
      status
      cognitoId
      email
      contactEmail
      unsubscribed
      firstName
      lastName
      phone
      userType
      driverCode
      suspendedAt
      suspendedBy
      suspensionReason
      reloadYardCarriers {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCarrierUser = /* GraphQL */ `
  subscription OnUpdateCarrierUser {
    onUpdateCarrierUser {
      id
      status
      cognitoId
      email
      contactEmail
      unsubscribed
      firstName
      lastName
      phone
      userType
      driverCode
      suspendedAt
      suspendedBy
      suspensionReason
      reloadYardCarriers {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCarrierUser = /* GraphQL */ `
  subscription OnDeleteCarrierUser {
    onDeleteCarrierUser {
      id
      status
      cognitoId
      email
      contactEmail
      unsubscribed
      firstName
      lastName
      phone
      userType
      driverCode
      suspendedAt
      suspendedBy
      suspensionReason
      reloadYardCarriers {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCarrierUserReloadYardCarrier = /* GraphQL */ `
  subscription OnCreateCarrierUserReloadYardCarrier($owner: String) {
    onCreateCarrierUserReloadYardCarrier(owner: $owner) {
      id
      owner
      groups
      active
      deleted
      carrierUserId
      user {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      businessName
      firstName
      lastName
      email
      phone
      type
      description
      acl
      photo {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes
      blockAccess
      createdVia
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCarrierUserReloadYardCarrier = /* GraphQL */ `
  subscription OnUpdateCarrierUserReloadYardCarrier($owner: String) {
    onUpdateCarrierUserReloadYardCarrier(owner: $owner) {
      id
      owner
      groups
      active
      deleted
      carrierUserId
      user {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      businessName
      firstName
      lastName
      email
      phone
      type
      description
      acl
      photo {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes
      blockAccess
      createdVia
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCarrierUserReloadYardCarrier = /* GraphQL */ `
  subscription OnDeleteCarrierUserReloadYardCarrier($owner: String) {
    onDeleteCarrierUserReloadYardCarrier(owner: $owner) {
      id
      owner
      groups
      active
      deleted
      carrierUserId
      user {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      businessName
      firstName
      lastName
      email
      phone
      type
      description
      acl
      photo {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes
      blockAccess
      createdVia
      createdAt
      updatedAt
    }
  }
`;
export const onCreateChargeRule = /* GraphQL */ `
  subscription OnCreateChargeRule($owner: String) {
    onCreateChargeRule(owner: $owner) {
      id
      owner
      active
      groups
      accountId
      reloadYardId
      event
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      billingUOM
      reloadYardCommodityId
      carrierType
      carrierEquipmentTypeId
      areaId
      zoneId
      graduatedRates {
        days
        rate
      }
      minCharge
      maxCharge
      execution
      frequency
      feeAccrual
      freeDaysPolicy
      freeDays
      freeCars
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateChargeRule = /* GraphQL */ `
  subscription OnUpdateChargeRule($owner: String) {
    onUpdateChargeRule(owner: $owner) {
      id
      owner
      active
      groups
      accountId
      reloadYardId
      event
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      billingUOM
      reloadYardCommodityId
      carrierType
      carrierEquipmentTypeId
      areaId
      zoneId
      graduatedRates {
        days
        rate
      }
      minCharge
      maxCharge
      execution
      frequency
      feeAccrual
      freeDaysPolicy
      freeDays
      freeCars
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteChargeRule = /* GraphQL */ `
  subscription OnDeleteChargeRule($owner: String) {
    onDeleteChargeRule(owner: $owner) {
      id
      owner
      active
      groups
      accountId
      reloadYardId
      event
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      billingUOM
      reloadYardCommodityId
      carrierType
      carrierEquipmentTypeId
      areaId
      zoneId
      graduatedRates {
        days
        rate
      }
      minCharge
      maxCharge
      execution
      frequency
      feeAccrual
      freeDaysPolicy
      freeDays
      freeCars
      createdAt
      updatedAt
    }
  }
`;
export const onCreateChecklist = /* GraphQL */ `
  subscription OnCreateChecklist($owner: String) {
    onCreateChecklist(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      resourceId
      name
      description
      processName
      checklistItems {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      reloadYardCommodityId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateChecklist = /* GraphQL */ `
  subscription OnUpdateChecklist($owner: String) {
    onUpdateChecklist(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      resourceId
      name
      description
      processName
      checklistItems {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      reloadYardCommodityId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteChecklist = /* GraphQL */ `
  subscription OnDeleteChecklist($owner: String) {
    onDeleteChecklist(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      resourceId
      name
      description
      processName
      checklistItems {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      reloadYardCommodityId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCommodity = /* GraphQL */ `
  subscription OnCreateCommodity {
    onCreateCommodity {
      id
      active
      sortKey
      name
      description
      defaultUnits
      locationLoadType
      validUom
      inventoryFields
      enableCounter
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCommodity = /* GraphQL */ `
  subscription OnUpdateCommodity {
    onUpdateCommodity {
      id
      active
      sortKey
      name
      description
      defaultUnits
      locationLoadType
      validUom
      inventoryFields
      enableCounter
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCommodity = /* GraphQL */ `
  subscription OnDeleteCommodity {
    onDeleteCommodity {
      id
      active
      sortKey
      name
      description
      defaultUnits
      locationLoadType
      validUom
      inventoryFields
      enableCounter
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCustomer = /* GraphQL */ `
  subscription OnCreateCustomer {
    onCreateCustomer {
      id
      status
      cognitoId
      email
      unsubscribed
      firstName
      lastName
      phone
      reloadYardAccounts {
        items {
          id
          owner
          active
          groups
          email
          lastName
          acl
          description
          customerId
          reloadYardId
          accountId
          accountName
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCustomer = /* GraphQL */ `
  subscription OnUpdateCustomer {
    onUpdateCustomer {
      id
      status
      cognitoId
      email
      unsubscribed
      firstName
      lastName
      phone
      reloadYardAccounts {
        items {
          id
          owner
          active
          groups
          email
          lastName
          acl
          description
          customerId
          reloadYardId
          accountId
          accountName
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCustomer = /* GraphQL */ `
  subscription OnDeleteCustomer {
    onDeleteCustomer {
      id
      status
      cognitoId
      email
      unsubscribed
      firstName
      lastName
      phone
      reloadYardAccounts {
        items {
          id
          owner
          active
          groups
          email
          lastName
          acl
          description
          customerId
          reloadYardId
          accountId
          accountName
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCustomerReloadYardAccount = /* GraphQL */ `
  subscription OnCreateCustomerReloadYardAccount($owner: String) {
    onCreateCustomerReloadYardAccount(owner: $owner) {
      id
      owner
      active
      groups
      email
      lastName
      acl
      description
      customerId
      customer {
        id
        status
        cognitoId
        email
        unsubscribed
        firstName
        lastName
        phone
        reloadYardAccounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      accountId
      accountName
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCustomerReloadYardAccount = /* GraphQL */ `
  subscription OnUpdateCustomerReloadYardAccount($owner: String) {
    onUpdateCustomerReloadYardAccount(owner: $owner) {
      id
      owner
      active
      groups
      email
      lastName
      acl
      description
      customerId
      customer {
        id
        status
        cognitoId
        email
        unsubscribed
        firstName
        lastName
        phone
        reloadYardAccounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      accountId
      accountName
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCustomerReloadYardAccount = /* GraphQL */ `
  subscription OnDeleteCustomerReloadYardAccount($owner: String) {
    onDeleteCustomerReloadYardAccount(owner: $owner) {
      id
      owner
      active
      groups
      email
      lastName
      acl
      description
      customerId
      customer {
        id
        status
        cognitoId
        email
        unsubscribed
        firstName
        lastName
        phone
        reloadYardAccounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      accountId
      accountName
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateEventType = /* GraphQL */ `
  subscription OnCreateEventType($owner: String) {
    onCreateEventType(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      description
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      duration
      bufferTime
      resourceName
      numberOfResources
      assetTypeId
      assetType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        maxConcurrentBookings
        createdAt
        updatedAt
      }
      workflow
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateEventType = /* GraphQL */ `
  subscription OnUpdateEventType($owner: String) {
    onUpdateEventType(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      description
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      duration
      bufferTime
      resourceName
      numberOfResources
      assetTypeId
      assetType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        maxConcurrentBookings
        createdAt
        updatedAt
      }
      workflow
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteEventType = /* GraphQL */ `
  subscription OnDeleteEventType($owner: String) {
    onDeleteEventType(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      description
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      duration
      bufferTime
      resourceName
      numberOfResources
      assetTypeId
      assetType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        maxConcurrentBookings
        createdAt
        updatedAt
      }
      workflow
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateFile = /* GraphQL */ `
  subscription OnCreateFile($owner: String) {
    onCreateFile(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      displayName
      rawFileName
      description
      contentDate
      category
      visibility
      file {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateFile = /* GraphQL */ `
  subscription OnUpdateFile($owner: String) {
    onUpdateFile(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      displayName
      rawFileName
      description
      contentDate
      category
      visibility
      file {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteFile = /* GraphQL */ `
  subscription OnDeleteFile($owner: String) {
    onDeleteFile(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      displayName
      rawFileName
      description
      contentDate
      category
      visibility
      file {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateHelpPage = /* GraphQL */ `
  subscription OnCreateHelpPage {
    onCreateHelpPage {
      id
      active
      isLive
      url
      topic
      name
      content
      kbFiles {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbMedia {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbContent {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateHelpPage = /* GraphQL */ `
  subscription OnUpdateHelpPage {
    onUpdateHelpPage {
      id
      active
      isLive
      url
      topic
      name
      content
      kbFiles {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbMedia {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbContent {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteHelpPage = /* GraphQL */ `
  subscription OnDeleteHelpPage {
    onDeleteHelpPage {
      id
      active
      isLive
      url
      topic
      name
      content
      kbFiles {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbMedia {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbContent {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateHistoryNote = /* GraphQL */ `
  subscription OnCreateHistoryNote($owner: String) {
    onCreateHistoryNote(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      text
      dateTime
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateHistoryNote = /* GraphQL */ `
  subscription OnUpdateHistoryNote($owner: String) {
    onUpdateHistoryNote(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      text
      dateTime
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteHistoryNote = /* GraphQL */ `
  subscription OnDeleteHistoryNote($owner: String) {
    onDeleteHistoryNote(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      text
      dateTime
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateInboundShipment = /* GraphQL */ `
  subscription OnCreateInboundShipment($owner: String) {
    onCreateInboundShipment(owner: $owner) {
      id
      owner
      groups
      active
      status
      state
      poNumber
      normalizedPoNumber
      lotNumber
      lotNumberOverride
      shipFrom
      carrierType
      originCarrier
      carrierName
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      lotType
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      totalUOM
      skipInvoice
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      advisedBy
      createDateTime
      scheduledDateTime
      notifyDateTime
      placedDateTime
      startDateTime
      endDateTime
      releaseDateTime
      collectedDateTime
      stripeBillingDateTime
      daysOnDemurrageClock
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptNumber
      assignedTo
      workflowType
      unloadedBy
      reviewedBy
      secondaryReview
      verificationRequired
      stockImport
      sit
      returnShipment
      returnOutboundShipmentId
      returnReason
      hasException
      unsafeShipment
      unsafeShipmentNote
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      checklistId
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      containerDrop
      containerNumber
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      stepName
      sealNumbers
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      braData {
        id
        owner
        groups
        reloadYardId
        accountId
        braSessionId
        braRawData
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateInboundShipment = /* GraphQL */ `
  subscription OnUpdateInboundShipment($owner: String) {
    onUpdateInboundShipment(owner: $owner) {
      id
      owner
      groups
      active
      status
      state
      poNumber
      normalizedPoNumber
      lotNumber
      lotNumberOverride
      shipFrom
      carrierType
      originCarrier
      carrierName
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      lotType
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      totalUOM
      skipInvoice
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      advisedBy
      createDateTime
      scheduledDateTime
      notifyDateTime
      placedDateTime
      startDateTime
      endDateTime
      releaseDateTime
      collectedDateTime
      stripeBillingDateTime
      daysOnDemurrageClock
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptNumber
      assignedTo
      workflowType
      unloadedBy
      reviewedBy
      secondaryReview
      verificationRequired
      stockImport
      sit
      returnShipment
      returnOutboundShipmentId
      returnReason
      hasException
      unsafeShipment
      unsafeShipmentNote
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      checklistId
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      containerDrop
      containerNumber
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      stepName
      sealNumbers
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      braData {
        id
        owner
        groups
        reloadYardId
        accountId
        braSessionId
        braRawData
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteInboundShipment = /* GraphQL */ `
  subscription OnDeleteInboundShipment($owner: String) {
    onDeleteInboundShipment(owner: $owner) {
      id
      owner
      groups
      active
      status
      state
      poNumber
      normalizedPoNumber
      lotNumber
      lotNumberOverride
      shipFrom
      carrierType
      originCarrier
      carrierName
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      lotType
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      totalUOM
      skipInvoice
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      advisedBy
      createDateTime
      scheduledDateTime
      notifyDateTime
      placedDateTime
      startDateTime
      endDateTime
      releaseDateTime
      collectedDateTime
      stripeBillingDateTime
      daysOnDemurrageClock
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptNumber
      assignedTo
      workflowType
      unloadedBy
      reviewedBy
      secondaryReview
      verificationRequired
      stockImport
      sit
      returnShipment
      returnOutboundShipmentId
      returnReason
      hasException
      unsafeShipment
      unsafeShipmentNote
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      checklistId
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      containerDrop
      containerNumber
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      stepName
      sealNumbers
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      braData {
        id
        owner
        groups
        reloadYardId
        accountId
        braSessionId
        braRawData
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateInventory = /* GraphQL */ `
  subscription OnCreateInventory($owner: String) {
    onCreateInventory(owner: $owner) {
      id
      owner
      groups
      active
      status
      lotNumber
      poNumber
      normalizedPoNumber
      railCarNumber
      normalizedRailCarNumber
      receivedAt
      depletedAt
      lastOutboundId
      turnDays
      quantityAdvised
      quantityReceived
      quantityPrecount
      quantityOnHand
      altQuantityOnHand
      quantityPhysical
      quantityCommitted
      altQuantityCommitted
      quantityMismatch
      inventoryUOM
      returnShipmentLineItemId
      pcs
      pcsHeight
      pcsWidth
      pcsLength
      pcsOnHand
      pcsCommitted
      weight
      weightUOM
      verificationRequired
      hasException
      overShipment
      overShipmentQuantity
      overShipmentNote
      underShipment
      underShipmentQuantity
      underShipmentNote
      isDamaged
      isRecalled
      recallNote
      otherException
      otherExceptionNote
      lotType
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleList
      containerNumber
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      productName
      braRawProductName
      rawDataInventoryId
      productCode
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      sortKey
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      workOrderId
      workOrder {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      auditId
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      aggregateInventoryId
      inventoryItems {
        items {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateInventory = /* GraphQL */ `
  subscription OnUpdateInventory($owner: String) {
    onUpdateInventory(owner: $owner) {
      id
      owner
      groups
      active
      status
      lotNumber
      poNumber
      normalizedPoNumber
      railCarNumber
      normalizedRailCarNumber
      receivedAt
      depletedAt
      lastOutboundId
      turnDays
      quantityAdvised
      quantityReceived
      quantityPrecount
      quantityOnHand
      altQuantityOnHand
      quantityPhysical
      quantityCommitted
      altQuantityCommitted
      quantityMismatch
      inventoryUOM
      returnShipmentLineItemId
      pcs
      pcsHeight
      pcsWidth
      pcsLength
      pcsOnHand
      pcsCommitted
      weight
      weightUOM
      verificationRequired
      hasException
      overShipment
      overShipmentQuantity
      overShipmentNote
      underShipment
      underShipmentQuantity
      underShipmentNote
      isDamaged
      isRecalled
      recallNote
      otherException
      otherExceptionNote
      lotType
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleList
      containerNumber
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      productName
      braRawProductName
      rawDataInventoryId
      productCode
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      sortKey
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      workOrderId
      workOrder {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      auditId
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      aggregateInventoryId
      inventoryItems {
        items {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteInventory = /* GraphQL */ `
  subscription OnDeleteInventory($owner: String) {
    onDeleteInventory(owner: $owner) {
      id
      owner
      groups
      active
      status
      lotNumber
      poNumber
      normalizedPoNumber
      railCarNumber
      normalizedRailCarNumber
      receivedAt
      depletedAt
      lastOutboundId
      turnDays
      quantityAdvised
      quantityReceived
      quantityPrecount
      quantityOnHand
      altQuantityOnHand
      quantityPhysical
      quantityCommitted
      altQuantityCommitted
      quantityMismatch
      inventoryUOM
      returnShipmentLineItemId
      pcs
      pcsHeight
      pcsWidth
      pcsLength
      pcsOnHand
      pcsCommitted
      weight
      weightUOM
      verificationRequired
      hasException
      overShipment
      overShipmentQuantity
      overShipmentNote
      underShipment
      underShipmentQuantity
      underShipmentNote
      isDamaged
      isRecalled
      recallNote
      otherException
      otherExceptionNote
      lotType
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleList
      containerNumber
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      productName
      braRawProductName
      rawDataInventoryId
      productCode
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      sortKey
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      workOrderId
      workOrder {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      auditId
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      aggregateInventoryId
      inventoryItems {
        items {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      createdAt
      updatedAt
    }
  }
`;
export const onCreateInventoryItem = /* GraphQL */ `
  subscription OnCreateInventoryItem($owner: String) {
    onCreateInventoryItem(owner: $owner) {
      id
      owner
      groups
      quantityOnHand
      altQuantityOnHand
      quantityCommitted
      altQuantityCommitted
      pcsOnHand
      pcsCommitted
      hasException
      isDamaged
      originOfDamage
      otherException
      otherExceptionNote
      status
      accountId
      inboundShipmentId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      barcode
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      locationFullName
      latitude
      longitude
      reloadYardId
      unloadedAt
      unloadedBy
      depletedAt
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      barcodes {
        items {
          id
          owner
          groups
          active
          status
          value
          isScanned
          scannedIn
          scannedOut
          reloadYardId
          inboundShipmentId
          inventoryId
          locationId
          inventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      history {
        type
        date
        by
        text
        public
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateInventoryItem = /* GraphQL */ `
  subscription OnUpdateInventoryItem($owner: String) {
    onUpdateInventoryItem(owner: $owner) {
      id
      owner
      groups
      quantityOnHand
      altQuantityOnHand
      quantityCommitted
      altQuantityCommitted
      pcsOnHand
      pcsCommitted
      hasException
      isDamaged
      originOfDamage
      otherException
      otherExceptionNote
      status
      accountId
      inboundShipmentId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      barcode
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      locationFullName
      latitude
      longitude
      reloadYardId
      unloadedAt
      unloadedBy
      depletedAt
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      barcodes {
        items {
          id
          owner
          groups
          active
          status
          value
          isScanned
          scannedIn
          scannedOut
          reloadYardId
          inboundShipmentId
          inventoryId
          locationId
          inventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      history {
        type
        date
        by
        text
        public
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteInventoryItem = /* GraphQL */ `
  subscription OnDeleteInventoryItem($owner: String) {
    onDeleteInventoryItem(owner: $owner) {
      id
      owner
      groups
      quantityOnHand
      altQuantityOnHand
      quantityCommitted
      altQuantityCommitted
      pcsOnHand
      pcsCommitted
      hasException
      isDamaged
      originOfDamage
      otherException
      otherExceptionNote
      status
      accountId
      inboundShipmentId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      barcode
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      locationFullName
      latitude
      longitude
      reloadYardId
      unloadedAt
      unloadedBy
      depletedAt
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      barcodes {
        items {
          id
          owner
          groups
          active
          status
          value
          isScanned
          scannedIn
          scannedOut
          reloadYardId
          inboundShipmentId
          inventoryId
          locationId
          inventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      history {
        type
        date
        by
        text
        public
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateInvoice = /* GraphQL */ `
  subscription OnCreateInvoice($owner: String) {
    onCreateInvoice(owner: $owner) {
      id
      owner
      groups
      active
      status
      invoiceNumber
      externalId
      externalUrl
      externalStatus
      poNumber
      poNumbers
      railCarNumbers
      pickupNumbers
      event
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      paymentTerms
      createDateTime
      dueDate
      overDue
      sentDate
      paidDate
      lineItems {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      subtotal
      discount
      adjustment
      tax
      total
      balance
      payments {
        id
        amount
        paymentDate
        method
        reference
        memo
        recordedBy
        recordedAt
      }
      paymentReferences
      notes
      customFields
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      contact {
        name
        email
        phone
        description
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateInvoice = /* GraphQL */ `
  subscription OnUpdateInvoice($owner: String) {
    onUpdateInvoice(owner: $owner) {
      id
      owner
      groups
      active
      status
      invoiceNumber
      externalId
      externalUrl
      externalStatus
      poNumber
      poNumbers
      railCarNumbers
      pickupNumbers
      event
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      paymentTerms
      createDateTime
      dueDate
      overDue
      sentDate
      paidDate
      lineItems {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      subtotal
      discount
      adjustment
      tax
      total
      balance
      payments {
        id
        amount
        paymentDate
        method
        reference
        memo
        recordedBy
        recordedAt
      }
      paymentReferences
      notes
      customFields
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      contact {
        name
        email
        phone
        description
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteInvoice = /* GraphQL */ `
  subscription OnDeleteInvoice($owner: String) {
    onDeleteInvoice(owner: $owner) {
      id
      owner
      groups
      active
      status
      invoiceNumber
      externalId
      externalUrl
      externalStatus
      poNumber
      poNumbers
      railCarNumbers
      pickupNumbers
      event
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      paymentTerms
      createDateTime
      dueDate
      overDue
      sentDate
      paidDate
      lineItems {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      subtotal
      discount
      adjustment
      tax
      total
      balance
      payments {
        id
        amount
        paymentDate
        method
        reference
        memo
        recordedBy
        recordedAt
      }
      paymentReferences
      notes
      customFields
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      contact {
        name
        email
        phone
        description
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateInvoiceService = /* GraphQL */ `
  subscription OnCreateInvoiceService($owner: String) {
    onCreateInvoiceService(owner: $owner) {
      id
      owner
      groups
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      event
      externalId
      sortKey
      accountId
      reloadYardId
      inboundShipmentId
      outboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      quantity
      units
      unitCost
      amount
      itemTax
      taxRate {
        taxCode
        name
        taxRate
      }
      itemTotal
      serviceNote
      serviceDate
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateInvoiceService = /* GraphQL */ `
  subscription OnUpdateInvoiceService($owner: String) {
    onUpdateInvoiceService(owner: $owner) {
      id
      owner
      groups
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      event
      externalId
      sortKey
      accountId
      reloadYardId
      inboundShipmentId
      outboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      quantity
      units
      unitCost
      amount
      itemTax
      taxRate {
        taxCode
        name
        taxRate
      }
      itemTotal
      serviceNote
      serviceDate
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteInvoiceService = /* GraphQL */ `
  subscription OnDeleteInvoiceService($owner: String) {
    onDeleteInvoiceService(owner: $owner) {
      id
      owner
      groups
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      event
      externalId
      sortKey
      accountId
      reloadYardId
      inboundShipmentId
      outboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      quantity
      units
      unitCost
      amount
      itemTax
      taxRate {
        taxCode
        name
        taxRate
      }
      itemTotal
      serviceNote
      serviceDate
      createdAt
      updatedAt
    }
  }
`;
export const onCreateLocation = /* GraphQL */ `
  subscription OnCreateLocation($owner: String) {
    onCreateLocation(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      accountName
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      aisle {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        locations {
          nextToken
        }
        bays
        levels
        positions
        totalLocations
        capacityUsed
        length
        width
        sortKey
        topDownPickOrder
        createdAt
        updatedAt
      }
      bay
      level
      position
      capacityAllocated
      capacityUsed
      length
      width
      sortKey
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      productId
      productName
      bulkCapacity
      bulkUnits
      isContaminated
      containerNumber
      tags {
        items {
          id
          owner
          groups
          reloadYardId
          locationId
          tagId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateLocation = /* GraphQL */ `
  subscription OnUpdateLocation($owner: String) {
    onUpdateLocation(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      accountName
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      aisle {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        locations {
          nextToken
        }
        bays
        levels
        positions
        totalLocations
        capacityUsed
        length
        width
        sortKey
        topDownPickOrder
        createdAt
        updatedAt
      }
      bay
      level
      position
      capacityAllocated
      capacityUsed
      length
      width
      sortKey
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      productId
      productName
      bulkCapacity
      bulkUnits
      isContaminated
      containerNumber
      tags {
        items {
          id
          owner
          groups
          reloadYardId
          locationId
          tagId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteLocation = /* GraphQL */ `
  subscription OnDeleteLocation($owner: String) {
    onDeleteLocation(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      accountName
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      aisle {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        locations {
          nextToken
        }
        bays
        levels
        positions
        totalLocations
        capacityUsed
        length
        width
        sortKey
        topDownPickOrder
        createdAt
        updatedAt
      }
      bay
      level
      position
      capacityAllocated
      capacityUsed
      length
      width
      sortKey
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      productId
      productName
      bulkCapacity
      bulkUnits
      isContaminated
      containerNumber
      tags {
        items {
          id
          owner
          groups
          reloadYardId
          locationId
          tagId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateLocationTag = /* GraphQL */ `
  subscription OnCreateLocationTag($owner: String) {
    onCreateLocationTag(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      tagId
      tag {
        id
        owner
        groups
        reloadYardId
        name
        description
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateLocationTag = /* GraphQL */ `
  subscription OnUpdateLocationTag($owner: String) {
    onUpdateLocationTag(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      tagId
      tag {
        id
        owner
        groups
        reloadYardId
        name
        description
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteLocationTag = /* GraphQL */ `
  subscription OnDeleteLocationTag($owner: String) {
    onDeleteLocationTag(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      tagId
      tag {
        id
        owner
        groups
        reloadYardId
        name
        description
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateLog = /* GraphQL */ `
  subscription OnCreateLog($owner: String) {
    onCreateLog(owner: $owner) {
      id
      status
      createdAt
      appType
      tenantId
      user
      message
      exception
      appVersion
      url
      context
      owner
      updatedAt
    }
  }
`;
export const onUpdateLog = /* GraphQL */ `
  subscription OnUpdateLog($owner: String) {
    onUpdateLog(owner: $owner) {
      id
      status
      createdAt
      appType
      tenantId
      user
      message
      exception
      appVersion
      url
      context
      owner
      updatedAt
    }
  }
`;
export const onDeleteLog = /* GraphQL */ `
  subscription OnDeleteLog($owner: String) {
    onDeleteLog(owner: $owner) {
      id
      status
      createdAt
      appType
      tenantId
      user
      message
      exception
      appVersion
      url
      context
      owner
      updatedAt
    }
  }
`;
export const onCreateOutboundShipment = /* GraphQL */ `
  subscription OnCreateOutboundShipment($owner: String) {
    onCreateOutboundShipment(owner: $owner) {
      id
      owner
      groups
      active
      status
      state
      transfer
      transferToAccountId
      transferToAccountName
      poNumber
      pickupNumber
      consigneePoNumber
      normalizedPoNumber
      normalizedPickupNumber
      normalizedConsigneePoNumber
      shipTo {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      carrierType
      carrier
      carrierName
      carrierId
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      bolNumber
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      mustTarp
      didTarp
      containerPickup
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      createDateTime
      scheduledDateTime
      arrivalDateTime
      placementDateTime
      startDateTime
      endDateTime
      departureDateTime
      collectedDateTime
      deliveryDateTime
      daysOnDemurrageClock
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      totalUOM
      skipInvoice
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      sealNumber
      assignedTo
      instructions
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      shipWithGroupId
      shipWithIds
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      advisedBy
      inspectedBy
      stepName
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      hasException
      returnShipment
      returnReason
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateOutboundShipment = /* GraphQL */ `
  subscription OnUpdateOutboundShipment($owner: String) {
    onUpdateOutboundShipment(owner: $owner) {
      id
      owner
      groups
      active
      status
      state
      transfer
      transferToAccountId
      transferToAccountName
      poNumber
      pickupNumber
      consigneePoNumber
      normalizedPoNumber
      normalizedPickupNumber
      normalizedConsigneePoNumber
      shipTo {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      carrierType
      carrier
      carrierName
      carrierId
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      bolNumber
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      mustTarp
      didTarp
      containerPickup
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      createDateTime
      scheduledDateTime
      arrivalDateTime
      placementDateTime
      startDateTime
      endDateTime
      departureDateTime
      collectedDateTime
      deliveryDateTime
      daysOnDemurrageClock
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      totalUOM
      skipInvoice
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      sealNumber
      assignedTo
      instructions
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      shipWithGroupId
      shipWithIds
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      advisedBy
      inspectedBy
      stepName
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      hasException
      returnShipment
      returnReason
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteOutboundShipment = /* GraphQL */ `
  subscription OnDeleteOutboundShipment($owner: String) {
    onDeleteOutboundShipment(owner: $owner) {
      id
      owner
      groups
      active
      status
      state
      transfer
      transferToAccountId
      transferToAccountName
      poNumber
      pickupNumber
      consigneePoNumber
      normalizedPoNumber
      normalizedPickupNumber
      normalizedConsigneePoNumber
      shipTo {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      carrierType
      carrier
      carrierName
      carrierId
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      bolNumber
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      mustTarp
      didTarp
      containerPickup
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      createDateTime
      scheduledDateTime
      arrivalDateTime
      placementDateTime
      startDateTime
      endDateTime
      departureDateTime
      collectedDateTime
      deliveryDateTime
      daysOnDemurrageClock
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      totalUOM
      skipInvoice
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      sealNumber
      assignedTo
      instructions
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      shipWithGroupId
      shipWithIds
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      advisedBy
      inspectedBy
      stepName
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      hasException
      returnShipment
      returnReason
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePaymentTerm = /* GraphQL */ `
  subscription OnCreatePaymentTerm($owner: String) {
    onCreatePaymentTerm(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      name
      code
      type
      dueDays
      dayOfMonthDue
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePaymentTerm = /* GraphQL */ `
  subscription OnUpdatePaymentTerm($owner: String) {
    onUpdatePaymentTerm(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      name
      code
      type
      dueDays
      dayOfMonthDue
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePaymentTerm = /* GraphQL */ `
  subscription OnDeletePaymentTerm($owner: String) {
    onDeletePaymentTerm(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      name
      code
      type
      dueDays
      dayOfMonthDue
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePhoto = /* GraphQL */ `
  subscription OnCreatePhoto {
    onCreatePhoto {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      bucket
      region
      key
      type
      name
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePhoto = /* GraphQL */ `
  subscription OnUpdatePhoto {
    onUpdatePhoto {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      bucket
      region
      key
      type
      name
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePhoto = /* GraphQL */ `
  subscription OnDeletePhoto {
    onDeletePhoto {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      bucket
      region
      key
      type
      name
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateProduct = /* GraphQL */ `
  subscription OnCreateProduct($owner: String) {
    onCreateProduct(owner: $owner) {
      id
      owner
      groups
      active
      accountId
      reloadYardId
      name
      altNames
      productCode
      reloadYardCommodityId
      category
      defaultUOM
      defaultWeightUOM
      unit
      pcs
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      height
      width
      length
      pcsHeight
      pcsWidth
      pcsLength
      lowInventoryThreshold
      totalInventoryQuantity
      totalQuantityOnHand
      totalQuantityCommitted
      lowInventoryAlert
      customFields
      color
      status
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      velocityStats {
        id
        owner
        groups
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        stats
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateProduct = /* GraphQL */ `
  subscription OnUpdateProduct($owner: String) {
    onUpdateProduct(owner: $owner) {
      id
      owner
      groups
      active
      accountId
      reloadYardId
      name
      altNames
      productCode
      reloadYardCommodityId
      category
      defaultUOM
      defaultWeightUOM
      unit
      pcs
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      height
      width
      length
      pcsHeight
      pcsWidth
      pcsLength
      lowInventoryThreshold
      totalInventoryQuantity
      totalQuantityOnHand
      totalQuantityCommitted
      lowInventoryAlert
      customFields
      color
      status
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      velocityStats {
        id
        owner
        groups
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        stats
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteProduct = /* GraphQL */ `
  subscription OnDeleteProduct($owner: String) {
    onDeleteProduct(owner: $owner) {
      id
      owner
      groups
      active
      accountId
      reloadYardId
      name
      altNames
      productCode
      reloadYardCommodityId
      category
      defaultUOM
      defaultWeightUOM
      unit
      pcs
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      height
      width
      length
      pcsHeight
      pcsWidth
      pcsLength
      lowInventoryThreshold
      totalInventoryQuantity
      totalQuantityOnHand
      totalQuantityCommitted
      lowInventoryAlert
      customFields
      color
      status
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      velocityStats {
        id
        owner
        groups
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        stats
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateProductStats = /* GraphQL */ `
  subscription OnCreateProductStats($owner: String) {
    onCreateProductStats(owner: $owner) {
      id
      owner
      groups
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      stats
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateProductStats = /* GraphQL */ `
  subscription OnUpdateProductStats($owner: String) {
    onUpdateProductStats(owner: $owner) {
      id
      owner
      groups
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      stats
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteProductStats = /* GraphQL */ `
  subscription OnDeleteProductStats($owner: String) {
    onDeleteProductStats(owner: $owner) {
      id
      owner
      groups
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      stats
      createdAt
      updatedAt
    }
  }
`;
export const onCreateRailEquipmentType = /* GraphQL */ `
  subscription OnCreateRailEquipmentType($owner: String) {
    onCreateRailEquipmentType(owner: $owner) {
      id
      owner
      groups
      active
      name
      arrTypeCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateRailEquipmentType = /* GraphQL */ `
  subscription OnUpdateRailEquipmentType($owner: String) {
    onUpdateRailEquipmentType(owner: $owner) {
      id
      owner
      groups
      active
      name
      arrTypeCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteRailEquipmentType = /* GraphQL */ `
  subscription OnDeleteRailEquipmentType($owner: String) {
    onDeleteRailEquipmentType(owner: $owner) {
      id
      owner
      groups
      active
      name
      arrTypeCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const onCreateRawData = /* GraphQL */ `
  subscription OnCreateRawData($owner: String) {
    onCreateRawData(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      accountId
      braSessionId
      braRawData
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateRawData = /* GraphQL */ `
  subscription OnUpdateRawData($owner: String) {
    onUpdateRawData(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      accountId
      braSessionId
      braRawData
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteRawData = /* GraphQL */ `
  subscription OnDeleteRawData($owner: String) {
    onDeleteRawData(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      accountId
      braSessionId
      braRawData
      createdAt
      updatedAt
    }
  }
`;
export const onCreateReloadYard = /* GraphQL */ `
  subscription OnCreateReloadYard($owner: String) {
    onCreateReloadYard(owner: $owner) {
      id
      owner
      groups
      active
      status
      name
      phone
      fax
      email
      website
      street
      city
      state
      zipCode
      country
      latitude
      longitude
      geofence
      geofenceToleranceMeters
      geofenceEnabled
      geofenceEnforced
      driverCheckInEnabled
      driverIdentificationRequired
      driverIdScanRequired
      driverCheckInGraceMinutes
      driverCheckInWithoutAppointment
      driverInstructions
      postCheckInMessage
      driverStops {
        label
        message
      }
      driverIdImageRetention
      lotCapacity
      trackCapacity
      warehouseCapacity
      servingCarrier
      railHighway
      ast
      externalCompanyId
      taxRates {
        taxCode
        name
        taxRate
      }
      paymentTerms {
        items {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceNumberPrefix
      invoiceCounter
      remittanceAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolCounter
      receiptCounter
      fileCategories {
        key
        name
      }
      mapImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      logoImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      areas {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      yardCommodities {
        items {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      subscription {
        customerId
        subscriptionId
        priceId
        name
        status
      }
      tosAccept {
        acceptTimeStamp
        cognitoId
        email
        userAgent
        ip
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      timeZone
      railEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      truckEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      assetTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        nextToken
      }
      eventTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      apiKeys {
        items {
          id
          active
          groups
          reloadYardId
          name
          keyId
          createdBy
          deletedBy
          createdAt
          updatedAt
        }
        nextToken
      }
      invoicesProcessedAt
      reportsProcessedAt
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateReloadYard = /* GraphQL */ `
  subscription OnUpdateReloadYard($owner: String) {
    onUpdateReloadYard(owner: $owner) {
      id
      owner
      groups
      active
      status
      name
      phone
      fax
      email
      website
      street
      city
      state
      zipCode
      country
      latitude
      longitude
      geofence
      geofenceToleranceMeters
      geofenceEnabled
      geofenceEnforced
      driverCheckInEnabled
      driverIdentificationRequired
      driverIdScanRequired
      driverCheckInGraceMinutes
      driverCheckInWithoutAppointment
      driverInstructions
      postCheckInMessage
      driverStops {
        label
        message
      }
      driverIdImageRetention
      lotCapacity
      trackCapacity
      warehouseCapacity
      servingCarrier
      railHighway
      ast
      externalCompanyId
      taxRates {
        taxCode
        name
        taxRate
      }
      paymentTerms {
        items {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceNumberPrefix
      invoiceCounter
      remittanceAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolCounter
      receiptCounter
      fileCategories {
        key
        name
      }
      mapImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      logoImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      areas {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      yardCommodities {
        items {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      subscription {
        customerId
        subscriptionId
        priceId
        name
        status
      }
      tosAccept {
        acceptTimeStamp
        cognitoId
        email
        userAgent
        ip
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      timeZone
      railEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      truckEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      assetTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        nextToken
      }
      eventTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      apiKeys {
        items {
          id
          active
          groups
          reloadYardId
          name
          keyId
          createdBy
          deletedBy
          createdAt
          updatedAt
        }
        nextToken
      }
      invoicesProcessedAt
      reportsProcessedAt
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteReloadYard = /* GraphQL */ `
  subscription OnDeleteReloadYard($owner: String) {
    onDeleteReloadYard(owner: $owner) {
      id
      owner
      groups
      active
      status
      name
      phone
      fax
      email
      website
      street
      city
      state
      zipCode
      country
      latitude
      longitude
      geofence
      geofenceToleranceMeters
      geofenceEnabled
      geofenceEnforced
      driverCheckInEnabled
      driverIdentificationRequired
      driverIdScanRequired
      driverCheckInGraceMinutes
      driverCheckInWithoutAppointment
      driverInstructions
      postCheckInMessage
      driverStops {
        label
        message
      }
      driverIdImageRetention
      lotCapacity
      trackCapacity
      warehouseCapacity
      servingCarrier
      railHighway
      ast
      externalCompanyId
      taxRates {
        taxCode
        name
        taxRate
      }
      paymentTerms {
        items {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceNumberPrefix
      invoiceCounter
      remittanceAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolCounter
      receiptCounter
      fileCategories {
        key
        name
      }
      mapImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      logoImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      areas {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      yardCommodities {
        items {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      subscription {
        customerId
        subscriptionId
        priceId
        name
        status
      }
      tosAccept {
        acceptTimeStamp
        cognitoId
        email
        userAgent
        ip
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      timeZone
      railEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      truckEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      assetTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        nextToken
      }
      eventTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      apiKeys {
        items {
          id
          active
          groups
          reloadYardId
          name
          keyId
          createdBy
          deletedBy
          createdAt
          updatedAt
        }
        nextToken
      }
      invoicesProcessedAt
      reportsProcessedAt
      createdAt
      updatedAt
    }
  }
`;
export const onCreateReloadYardCapability = /* GraphQL */ `
  subscription OnCreateReloadYardCapability($owner: String) {
    onCreateReloadYardCapability(owner: $owner) {
      id
      reloadYardId
      capabilityId
      owner
      groups
      active
      verified
      requiredValue
      capability {
        id
        active
        sortKey
        name
        description
        requiresValue
        requiredValueLabel
        quantity
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateReloadYardCapability = /* GraphQL */ `
  subscription OnUpdateReloadYardCapability($owner: String) {
    onUpdateReloadYardCapability(owner: $owner) {
      id
      reloadYardId
      capabilityId
      owner
      groups
      active
      verified
      requiredValue
      capability {
        id
        active
        sortKey
        name
        description
        requiresValue
        requiredValueLabel
        quantity
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteReloadYardCapability = /* GraphQL */ `
  subscription OnDeleteReloadYardCapability($owner: String) {
    onDeleteReloadYardCapability(owner: $owner) {
      id
      reloadYardId
      capabilityId
      owner
      groups
      active
      verified
      requiredValue
      capability {
        id
        active
        sortKey
        name
        description
        requiresValue
        requiredValueLabel
        quantity
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateReloadYardCommodity = /* GraphQL */ `
  subscription OnCreateReloadYardCommodity($owner: String) {
    onCreateReloadYardCommodity(owner: $owner) {
      id
      reloadYardId
      commodityId
      owner
      groups
      active
      verified
      units
      showCounter
      sortKey
      commodity {
        id
        active
        sortKey
        name
        description
        defaultUnits
        locationLoadType
        validUom
        inventoryFields
        enableCounter
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateReloadYardCommodity = /* GraphQL */ `
  subscription OnUpdateReloadYardCommodity($owner: String) {
    onUpdateReloadYardCommodity(owner: $owner) {
      id
      reloadYardId
      commodityId
      owner
      groups
      active
      verified
      units
      showCounter
      sortKey
      commodity {
        id
        active
        sortKey
        name
        description
        defaultUnits
        locationLoadType
        validUom
        inventoryFields
        enableCounter
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteReloadYardCommodity = /* GraphQL */ `
  subscription OnDeleteReloadYardCommodity($owner: String) {
    onDeleteReloadYardCommodity(owner: $owner) {
      id
      reloadYardId
      commodityId
      owner
      groups
      active
      verified
      units
      showCounter
      sortKey
      commodity {
        id
        active
        sortKey
        name
        description
        defaultUnits
        locationLoadType
        validUom
        inventoryFields
        enableCounter
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSavedAddress = /* GraphQL */ `
  subscription OnCreateSavedAddress($owner: String) {
    onCreateSavedAddress(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      accountId
      name
      street
      city
      state
      zipCode
      country
      phone
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateSavedAddress = /* GraphQL */ `
  subscription OnUpdateSavedAddress($owner: String) {
    onUpdateSavedAddress(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      accountId
      name
      street
      city
      state
      zipCode
      country
      phone
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteSavedAddress = /* GraphQL */ `
  subscription OnDeleteSavedAddress($owner: String) {
    onDeleteSavedAddress(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      accountId
      name
      street
      city
      state
      zipCode
      country
      phone
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSeal = /* GraphQL */ `
  subscription OnCreateSeal($owner: String) {
    onCreateSeal(owner: $owner) {
      id
      active
      owner
      groups
      reloadYardId
      accountId
      accountName
      referenceId
      referenceName
      barcode
      isScanned
      createdAt
      createdBy
      validated
      reValidated
      brokenAt
      brokenBy
      description
      status
      updatedAt
    }
  }
`;
export const onUpdateSeal = /* GraphQL */ `
  subscription OnUpdateSeal($owner: String) {
    onUpdateSeal(owner: $owner) {
      id
      active
      owner
      groups
      reloadYardId
      accountId
      accountName
      referenceId
      referenceName
      barcode
      isScanned
      createdAt
      createdBy
      validated
      reValidated
      brokenAt
      brokenBy
      description
      status
      updatedAt
    }
  }
`;
export const onDeleteSeal = /* GraphQL */ `
  subscription OnDeleteSeal($owner: String) {
    onDeleteSeal(owner: $owner) {
      id
      active
      owner
      groups
      reloadYardId
      accountId
      accountName
      referenceId
      referenceName
      barcode
      isScanned
      createdAt
      createdBy
      validated
      reValidated
      brokenAt
      brokenBy
      description
      status
      updatedAt
    }
  }
`;
export const onCreateService = /* GraphQL */ `
  subscription OnCreateService($owner: String) {
    onCreateService(owner: $owner) {
      id
      owner
      groups
      active
      status
      reloadYardId
      accountName
      accountId
      name
      description
      taxRate {
        taxCode
        name
        taxRate
      }
      unit
      pcs
      car
      tl
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateService = /* GraphQL */ `
  subscription OnUpdateService($owner: String) {
    onUpdateService(owner: $owner) {
      id
      owner
      groups
      active
      status
      reloadYardId
      accountName
      accountId
      name
      description
      taxRate {
        taxCode
        name
        taxRate
      }
      unit
      pcs
      car
      tl
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteService = /* GraphQL */ `
  subscription OnDeleteService($owner: String) {
    onDeleteService(owner: $owner) {
      id
      owner
      groups
      active
      status
      reloadYardId
      accountName
      accountId
      name
      description
      taxRate {
        taxCode
        name
        taxRate
      }
      unit
      pcs
      car
      tl
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSetupData = /* GraphQL */ `
  subscription OnCreateSetupData($owner: String) {
    onCreateSetupData(owner: $owner) {
      id
      owner
      groups
      status
      cognitoId
      firstName
      lastName
      businessName
      setupData
      submitDate
      approvalDate
      approvedBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateSetupData = /* GraphQL */ `
  subscription OnUpdateSetupData($owner: String) {
    onUpdateSetupData(owner: $owner) {
      id
      owner
      groups
      status
      cognitoId
      firstName
      lastName
      businessName
      setupData
      submitDate
      approvalDate
      approvedBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteSetupData = /* GraphQL */ `
  subscription OnDeleteSetupData($owner: String) {
    onDeleteSetupData(owner: $owner) {
      id
      owner
      groups
      status
      cognitoId
      firstName
      lastName
      businessName
      setupData
      submitDate
      approvalDate
      approvedBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateShipmentLineItem = /* GraphQL */ `
  subscription OnCreateShipmentLineItem($owner: String) {
    onCreateShipmentLineItem(owner: $owner) {
      id
      owner
      groups
      active
      status
      sortKey
      lotNumber
      poNumber
      totalQuantityToPick
      totalQuantityReturned
      units
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      pickupPhoto {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inventoryItems {
        items {
          id
          owner
          groups
          reloadYardId
          outboundShipmentId
          shipmentLineItemId
          inventoryId
          inventoryItemId
          quantityToPick
          quantityReturned
          scannedOut
          loadedBy
          units
          status
          hasException
          barcodeException
          barcodeExceptionNote
          otherException
          otherExceptionNote
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateShipmentLineItem = /* GraphQL */ `
  subscription OnUpdateShipmentLineItem($owner: String) {
    onUpdateShipmentLineItem(owner: $owner) {
      id
      owner
      groups
      active
      status
      sortKey
      lotNumber
      poNumber
      totalQuantityToPick
      totalQuantityReturned
      units
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      pickupPhoto {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inventoryItems {
        items {
          id
          owner
          groups
          reloadYardId
          outboundShipmentId
          shipmentLineItemId
          inventoryId
          inventoryItemId
          quantityToPick
          quantityReturned
          scannedOut
          loadedBy
          units
          status
          hasException
          barcodeException
          barcodeExceptionNote
          otherException
          otherExceptionNote
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteShipmentLineItem = /* GraphQL */ `
  subscription OnDeleteShipmentLineItem($owner: String) {
    onDeleteShipmentLineItem(owner: $owner) {
      id
      owner
      groups
      active
      status
      sortKey
      lotNumber
      poNumber
      totalQuantityToPick
      totalQuantityReturned
      units
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      pickupPhoto {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inventoryItems {
        items {
          id
          owner
          groups
          reloadYardId
          outboundShipmentId
          shipmentLineItemId
          inventoryId
          inventoryItemId
          quantityToPick
          quantityReturned
          scannedOut
          loadedBy
          units
          status
          hasException
          barcodeException
          barcodeExceptionNote
          otherException
          otherExceptionNote
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateShipmentLineItemInventoryItem = /* GraphQL */ `
  subscription OnCreateShipmentLineItemInventoryItem($owner: String) {
    onCreateShipmentLineItemInventoryItem(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      outboundShipmentId
      shipmentLineItemId
      inventoryId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      quantityToPick
      quantityReturned
      scannedOut
      loadedBy
      units
      status
      hasException
      barcodeException
      barcodeExceptionNote
      otherException
      otherExceptionNote
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateShipmentLineItemInventoryItem = /* GraphQL */ `
  subscription OnUpdateShipmentLineItemInventoryItem($owner: String) {
    onUpdateShipmentLineItemInventoryItem(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      outboundShipmentId
      shipmentLineItemId
      inventoryId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      quantityToPick
      quantityReturned
      scannedOut
      loadedBy
      units
      status
      hasException
      barcodeException
      barcodeExceptionNote
      otherException
      otherExceptionNote
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteShipmentLineItemInventoryItem = /* GraphQL */ `
  subscription OnDeleteShipmentLineItemInventoryItem($owner: String) {
    onDeleteShipmentLineItemInventoryItem(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      outboundShipmentId
      shipmentLineItemId
      inventoryId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      quantityToPick
      quantityReturned
      scannedOut
      loadedBy
      units
      status
      hasException
      barcodeException
      barcodeExceptionNote
      otherException
      otherExceptionNote
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSupportRequest = /* GraphQL */ `
  subscription OnCreateSupportRequest($owner: String) {
    onCreateSupportRequest(owner: $owner) {
      id
      owner
      groups
      active
      status
      reloadYardId
      subject
      description
      requirements
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      submittedAt
      approvedPriceCents
      maxRevisions
      approvedBy
      approvedAt
      quoteExpiresAt
      estimatedDays
      stripeCheckoutSessionId
      stripePaymentIntentId
      stripePaymentStatus
      paidAt
      startedAt
      deliveredAt
      revisionCount
      deliveryNotes
      deliveryAttachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateSupportRequest = /* GraphQL */ `
  subscription OnUpdateSupportRequest($owner: String) {
    onUpdateSupportRequest(owner: $owner) {
      id
      owner
      groups
      active
      status
      reloadYardId
      subject
      description
      requirements
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      submittedAt
      approvedPriceCents
      maxRevisions
      approvedBy
      approvedAt
      quoteExpiresAt
      estimatedDays
      stripeCheckoutSessionId
      stripePaymentIntentId
      stripePaymentStatus
      paidAt
      startedAt
      deliveredAt
      revisionCount
      deliveryNotes
      deliveryAttachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteSupportRequest = /* GraphQL */ `
  subscription OnDeleteSupportRequest($owner: String) {
    onDeleteSupportRequest(owner: $owner) {
      id
      owner
      groups
      active
      status
      reloadYardId
      subject
      description
      requirements
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      submittedAt
      approvedPriceCents
      maxRevisions
      approvedBy
      approvedAt
      quoteExpiresAt
      estimatedDays
      stripeCheckoutSessionId
      stripePaymentIntentId
      stripePaymentStatus
      paidAt
      startedAt
      deliveredAt
      revisionCount
      deliveryNotes
      deliveryAttachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateTag = /* GraphQL */ `
  subscription OnCreateTag($owner: String) {
    onCreateTag(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateTag = /* GraphQL */ `
  subscription OnUpdateTag($owner: String) {
    onUpdateTag(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteTag = /* GraphQL */ `
  subscription OnDeleteTag($owner: String) {
    onDeleteTag(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const onCreateTask = /* GraphQL */ `
  subscription OnCreateTask($owner: String) {
    onCreateTask(owner: $owner) {
      id
      owner
      groups
      status
      reloadYardId
      createdAt
      updatedAt
      name
      description
      assignedTo
      assignedToName
      allowReassign
      link
      priority
      reference
      category
      dueDate
      lateDate
      completedBy
      completedDate
      resolvedDate
      resolvedBy
      note
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
    }
  }
`;
export const onUpdateTask = /* GraphQL */ `
  subscription OnUpdateTask($owner: String) {
    onUpdateTask(owner: $owner) {
      id
      owner
      groups
      status
      reloadYardId
      createdAt
      updatedAt
      name
      description
      assignedTo
      assignedToName
      allowReassign
      link
      priority
      reference
      category
      dueDate
      lateDate
      completedBy
      completedDate
      resolvedDate
      resolvedBy
      note
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
    }
  }
`;
export const onDeleteTask = /* GraphQL */ `
  subscription OnDeleteTask($owner: String) {
    onDeleteTask(owner: $owner) {
      id
      owner
      groups
      status
      reloadYardId
      createdAt
      updatedAt
      name
      description
      assignedTo
      assignedToName
      allowReassign
      link
      priority
      reference
      category
      dueDate
      lateDate
      completedBy
      completedDate
      resolvedDate
      resolvedBy
      note
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
    }
  }
`;
export const onCreateTimeslot = /* GraphQL */ `
  subscription OnCreateTimeslot($owner: String) {
    onCreateTimeslot(owner: $owner) {
      id
      owner
      groups
      status
      reloadYardId
      year
      month
      week
      day
      time
      startTime
      endTime
      inboundId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountName
      accountId
      eventTypeId
      eventType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        description
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        duration
        bufferTime
        resourceName
        numberOfResources
        assetTypeId
        assetType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        workflow
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierUserId
      carrierUser {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateTimeslot = /* GraphQL */ `
  subscription OnUpdateTimeslot($owner: String) {
    onUpdateTimeslot(owner: $owner) {
      id
      owner
      groups
      status
      reloadYardId
      year
      month
      week
      day
      time
      startTime
      endTime
      inboundId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountName
      accountId
      eventTypeId
      eventType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        description
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        duration
        bufferTime
        resourceName
        numberOfResources
        assetTypeId
        assetType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        workflow
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierUserId
      carrierUser {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteTimeslot = /* GraphQL */ `
  subscription OnDeleteTimeslot($owner: String) {
    onDeleteTimeslot(owner: $owner) {
      id
      owner
      groups
      status
      reloadYardId
      year
      month
      week
      day
      time
      startTime
      endTime
      inboundId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountName
      accountId
      eventTypeId
      eventType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        description
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        duration
        bufferTime
        resourceName
        numberOfResources
        assetTypeId
        assetType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        workflow
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierUserId
      carrierUser {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateTrackCar = /* GraphQL */ `
  subscription OnCreateTrackCar {
    onCreateTrackCar {
      id
      active
      owner
      areaId
      zoneId
      aisleId
      trackId
      eodTrackId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      locationFullName
      reloadYardId
      accountId
      shipmentId
      parentType
      inbound {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outbound {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      railCarNumber
      sortKey
      eodSortKey
      movementLogs {
        trackCarId
        sortKey
        movedAt
        movedBy
      }
      updatedAt
      updatedBy
      createdAt
    }
  }
`;
export const onUpdateTrackCar = /* GraphQL */ `
  subscription OnUpdateTrackCar {
    onUpdateTrackCar {
      id
      active
      owner
      areaId
      zoneId
      aisleId
      trackId
      eodTrackId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      locationFullName
      reloadYardId
      accountId
      shipmentId
      parentType
      inbound {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outbound {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      railCarNumber
      sortKey
      eodSortKey
      movementLogs {
        trackCarId
        sortKey
        movedAt
        movedBy
      }
      updatedAt
      updatedBy
      createdAt
    }
  }
`;
export const onDeleteTrackCar = /* GraphQL */ `
  subscription OnDeleteTrackCar {
    onDeleteTrackCar {
      id
      active
      owner
      areaId
      zoneId
      aisleId
      trackId
      eodTrackId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      locationFullName
      reloadYardId
      accountId
      shipmentId
      parentType
      inbound {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outbound {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      railCarNumber
      sortKey
      eodSortKey
      movementLogs {
        trackCarId
        sortKey
        movedAt
        movedBy
      }
      updatedAt
      updatedBy
      createdAt
    }
  }
`;
export const onCreateTruckEquipmentType = /* GraphQL */ `
  subscription OnCreateTruckEquipmentType($owner: String) {
    onCreateTruckEquipmentType(owner: $owner) {
      id
      owner
      groups
      active
      name
      dotSpecCode
      dotClassCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateTruckEquipmentType = /* GraphQL */ `
  subscription OnUpdateTruckEquipmentType($owner: String) {
    onUpdateTruckEquipmentType(owner: $owner) {
      id
      owner
      groups
      active
      name
      dotSpecCode
      dotClassCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteTruckEquipmentType = /* GraphQL */ `
  subscription OnDeleteTruckEquipmentType($owner: String) {
    onDeleteTruckEquipmentType(owner: $owner) {
      id
      owner
      groups
      active
      name
      dotSpecCode
      dotClassCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser($owner: String) {
    onCreateUser(owner: $owner) {
      id
      owner
      groups
      active
      status
      cognitoId
      type
      firstName
      lastName
      fullName
      phone
      email
      unsubscribed
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      reloadYardId
      acl
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser($owner: String) {
    onUpdateUser(owner: $owner) {
      id
      owner
      groups
      active
      status
      cognitoId
      type
      firstName
      lastName
      fullName
      phone
      email
      unsubscribed
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      reloadYardId
      acl
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser($owner: String) {
    onDeleteUser(owner: $owner) {
      id
      owner
      groups
      active
      status
      cognitoId
      type
      firstName
      lastName
      fullName
      phone
      email
      unsubscribed
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      reloadYardId
      acl
      createdAt
      updatedAt
    }
  }
`;
export const onCreateWorkChargeRule = /* GraphQL */ `
  subscription OnCreateWorkChargeRule($owner: String) {
    onCreateWorkChargeRule(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      chargeRuleId
      chargeRule {
        id
        owner
        active
        groups
        accountId
        reloadYardId
        event
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        billingUOM
        reloadYardCommodityId
        carrierType
        carrierEquipmentTypeId
        areaId
        zoneId
        graduatedRates {
          days
          rate
        }
        minCharge
        maxCharge
        execution
        frequency
        feeAccrual
        freeDaysPolicy
        freeDays
        freeCars
        createdAt
        updatedAt
      }
      quantity
      sortKey
      invoiceServiceId
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateWorkChargeRule = /* GraphQL */ `
  subscription OnUpdateWorkChargeRule($owner: String) {
    onUpdateWorkChargeRule(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      chargeRuleId
      chargeRule {
        id
        owner
        active
        groups
        accountId
        reloadYardId
        event
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        billingUOM
        reloadYardCommodityId
        carrierType
        carrierEquipmentTypeId
        areaId
        zoneId
        graduatedRates {
          days
          rate
        }
        minCharge
        maxCharge
        execution
        frequency
        feeAccrual
        freeDaysPolicy
        freeDays
        freeCars
        createdAt
        updatedAt
      }
      quantity
      sortKey
      invoiceServiceId
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteWorkChargeRule = /* GraphQL */ `
  subscription OnDeleteWorkChargeRule($owner: String) {
    onDeleteWorkChargeRule(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      chargeRuleId
      chargeRule {
        id
        owner
        active
        groups
        accountId
        reloadYardId
        event
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        billingUOM
        reloadYardCommodityId
        carrierType
        carrierEquipmentTypeId
        areaId
        zoneId
        graduatedRates {
          days
          rate
        }
        minCharge
        maxCharge
        execution
        frequency
        feeAccrual
        freeDaysPolicy
        freeDays
        freeCars
        createdAt
        updatedAt
      }
      quantity
      sortKey
      invoiceServiceId
      createdAt
      updatedAt
    }
  }
`;
export const onCreateWorkOrder = /* GraphQL */ `
  subscription OnCreateWorkOrder($owner: String) {
    onCreateWorkOrder(owner: $owner) {
      id
      owner
      groups
      active
      status
      state
      workType
      poNumber
      normalizedPoNumber
      totalUOM
      skipInvoice
      createDateTime
      startDateTime
      endDateTime
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      assignedTo
      workflowType
      processedBy
      verificationRequired
      hasException
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      workOrderItems {
        items {
          id
          owner
          groups
          active
          status
          workOrderId
          sortKey
          poNumber
          quantityToProcess
          units
          accountId
          reloadYardId
          inputInventoryId
          inputInventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      outputInventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      stepName
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateWorkOrder = /* GraphQL */ `
  subscription OnUpdateWorkOrder($owner: String) {
    onUpdateWorkOrder(owner: $owner) {
      id
      owner
      groups
      active
      status
      state
      workType
      poNumber
      normalizedPoNumber
      totalUOM
      skipInvoice
      createDateTime
      startDateTime
      endDateTime
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      assignedTo
      workflowType
      processedBy
      verificationRequired
      hasException
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      workOrderItems {
        items {
          id
          owner
          groups
          active
          status
          workOrderId
          sortKey
          poNumber
          quantityToProcess
          units
          accountId
          reloadYardId
          inputInventoryId
          inputInventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      outputInventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      stepName
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteWorkOrder = /* GraphQL */ `
  subscription OnDeleteWorkOrder($owner: String) {
    onDeleteWorkOrder(owner: $owner) {
      id
      owner
      groups
      active
      status
      state
      workType
      poNumber
      normalizedPoNumber
      totalUOM
      skipInvoice
      createDateTime
      startDateTime
      endDateTime
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      assignedTo
      workflowType
      processedBy
      verificationRequired
      hasException
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      workOrderItems {
        items {
          id
          owner
          groups
          active
          status
          workOrderId
          sortKey
          poNumber
          quantityToProcess
          units
          accountId
          reloadYardId
          inputInventoryId
          inputInventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      outputInventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      stepName
      createdAt
      updatedAt
    }
  }
`;
export const onCreateWorkOrderItem = /* GraphQL */ `
  subscription OnCreateWorkOrderItem($owner: String) {
    onCreateWorkOrderItem(owner: $owner) {
      id
      owner
      groups
      active
      status
      workOrderId
      sortKey
      poNumber
      quantityToProcess
      units
      history {
        type
        date
        by
        text
        public
      }
      accountId
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inputInventoryItemId
      inputInventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateWorkOrderItem = /* GraphQL */ `
  subscription OnUpdateWorkOrderItem($owner: String) {
    onUpdateWorkOrderItem(owner: $owner) {
      id
      owner
      groups
      active
      status
      workOrderId
      sortKey
      poNumber
      quantityToProcess
      units
      history {
        type
        date
        by
        text
        public
      }
      accountId
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inputInventoryItemId
      inputInventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteWorkOrderItem = /* GraphQL */ `
  subscription OnDeleteWorkOrderItem($owner: String) {
    onDeleteWorkOrderItem(owner: $owner) {
      id
      owner
      groups
      active
      status
      workOrderId
      sortKey
      poNumber
      quantityToProcess
      units
      history {
        type
        date
        by
        text
        public
      }
      accountId
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inputInventoryItemId
      inputInventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateZapierHook = /* GraphQL */ `
  subscription OnCreateZapierHook {
    onCreateZapierHook {
      id
      groups
      active
      reloadYardId
      event
      zapId
      url
      link
      options
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateZapierHook = /* GraphQL */ `
  subscription OnUpdateZapierHook {
    onUpdateZapierHook {
      id
      groups
      active
      reloadYardId
      event
      zapId
      url
      link
      options
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteZapierHook = /* GraphQL */ `
  subscription OnDeleteZapierHook {
    onDeleteZapierHook {
      id
      groups
      active
      reloadYardId
      event
      zapId
      url
      link
      options
      createdAt
      updatedAt
    }
  }
`;
export const onCreateZapierAction = /* GraphQL */ `
  subscription OnCreateZapierAction {
    onCreateZapierAction {
      id
      groups
      active
      reloadYardId
      event
      name
      description
      counter
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateZapierAction = /* GraphQL */ `
  subscription OnUpdateZapierAction {
    onUpdateZapierAction {
      id
      groups
      active
      reloadYardId
      event
      name
      description
      counter
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteZapierAction = /* GraphQL */ `
  subscription OnDeleteZapierAction {
    onDeleteZapierAction {
      id
      groups
      active
      reloadYardId
      event
      name
      description
      counter
      createdAt
      updatedAt
    }
  }
`;
export const onCreateZone = /* GraphQL */ `
  subscription OnCreateZone($owner: String) {
    onCreateZone(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      accountId
      leasedArea
      leasedAreaUOM
      areaId
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      color
      zoneType
      reloadYardCommodityId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateZone = /* GraphQL */ `
  subscription OnUpdateZone($owner: String) {
    onUpdateZone(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      accountId
      leasedArea
      leasedAreaUOM
      areaId
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      color
      zoneType
      reloadYardCommodityId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteZone = /* GraphQL */ `
  subscription OnDeleteZone($owner: String) {
    onDeleteZone(owner: $owner) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      accountId
      leasedArea
      leasedAreaUOM
      areaId
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      color
      zoneType
      reloadYardCommodityId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCarrierUserIdentity = /* GraphQL */ `
  subscription OnCreateCarrierUserIdentity {
    onCreateCarrierUserIdentity {
      id
      status
      rekognitionFaceId
      rekognitionCollection
      faceImageKey
      idDocType
      idDocLast4
      idDocExpiry
      idDocState
      idDocClass
      idDocLastName
      idDocFirstInitial
      idDocImageKey
      idDocRetention
      idDocCapturedAt
      idDocSource
      idDocReplacedAt
      idDocDeletedAt
      consentAt
      consentVersion
      consentLocale
      consentTextHash
      faceConsentDeclinedAt
      consentWithdrawnAt
      consentWithdrawnBy
      enrolledVia
      enrolledBy
      enrolledAtYardId
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCarrierUserIdentity = /* GraphQL */ `
  subscription OnUpdateCarrierUserIdentity {
    onUpdateCarrierUserIdentity {
      id
      status
      rekognitionFaceId
      rekognitionCollection
      faceImageKey
      idDocType
      idDocLast4
      idDocExpiry
      idDocState
      idDocClass
      idDocLastName
      idDocFirstInitial
      idDocImageKey
      idDocRetention
      idDocCapturedAt
      idDocSource
      idDocReplacedAt
      idDocDeletedAt
      consentAt
      consentVersion
      consentLocale
      consentTextHash
      faceConsentDeclinedAt
      consentWithdrawnAt
      consentWithdrawnBy
      enrolledVia
      enrolledBy
      enrolledAtYardId
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCarrierUserIdentity = /* GraphQL */ `
  subscription OnDeleteCarrierUserIdentity {
    onDeleteCarrierUserIdentity {
      id
      status
      rekognitionFaceId
      rekognitionCollection
      faceImageKey
      idDocType
      idDocLast4
      idDocExpiry
      idDocState
      idDocClass
      idDocLastName
      idDocFirstInitial
      idDocImageKey
      idDocRetention
      idDocCapturedAt
      idDocSource
      idDocReplacedAt
      idDocDeletedAt
      consentAt
      consentVersion
      consentLocale
      consentTextHash
      faceConsentDeclinedAt
      consentWithdrawnAt
      consentWithdrawnBy
      enrolledVia
      enrolledBy
      enrolledAtYardId
      createdAt
      updatedAt
    }
  }
`;
export const onCreateDriverSession = /* GraphQL */ `
  subscription OnCreateDriverSession {
    onCreateDriverSession {
      id
      reloadYardId
      carrierUserId
      gateCheckInId
      ip
      userAgent
      windowStart
      searchCount
      identifyCount
      enrollCount
      captureCount
      revoked
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateDriverSession = /* GraphQL */ `
  subscription OnUpdateDriverSession {
    onUpdateDriverSession {
      id
      reloadYardId
      carrierUserId
      gateCheckInId
      ip
      userAgent
      windowStart
      searchCount
      identifyCount
      enrollCount
      captureCount
      revoked
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteDriverSession = /* GraphQL */ `
  subscription OnDeleteDriverSession {
    onDeleteDriverSession {
      id
      reloadYardId
      carrierUserId
      gateCheckInId
      ip
      userAgent
      windowStart
      searchCount
      identifyCount
      enrollCount
      captureCount
      revoked
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const onCreateGateCheckIn = /* GraphQL */ `
  subscription OnCreateGateCheckIn($owner: String) {
    onCreateGateCheckIn(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      driverSessionId
      carrierUserId
      carrierId
      carrierName
      driverName
      shipmentKey
      inboundId
      outboundId
      timeslotId
      scheduledDateTime
      referenceEntered
      driverNameEntered
      truckPlate
      trailerNumber
      latitude
      longitude
      locationAccuracy
      status
      dockAssignment
      arrivedAt
      calledAt
      completedAt
      updatedBy
      outboundIds
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateGateCheckIn = /* GraphQL */ `
  subscription OnUpdateGateCheckIn($owner: String) {
    onUpdateGateCheckIn(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      driverSessionId
      carrierUserId
      carrierId
      carrierName
      driverName
      shipmentKey
      inboundId
      outboundId
      timeslotId
      scheduledDateTime
      referenceEntered
      driverNameEntered
      truckPlate
      trailerNumber
      latitude
      longitude
      locationAccuracy
      status
      dockAssignment
      arrivedAt
      calledAt
      completedAt
      updatedBy
      outboundIds
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteGateCheckIn = /* GraphQL */ `
  subscription OnDeleteGateCheckIn($owner: String) {
    onDeleteGateCheckIn(owner: $owner) {
      id
      owner
      groups
      reloadYardId
      driverSessionId
      carrierUserId
      carrierId
      carrierName
      driverName
      shipmentKey
      inboundId
      outboundId
      timeslotId
      scheduledDateTime
      referenceEntered
      driverNameEntered
      truckPlate
      trailerNumber
      latitude
      longitude
      locationAccuracy
      status
      dockAssignment
      arrivedAt
      calledAt
      completedAt
      updatedBy
      outboundIds
      createdAt
      updatedAt
    }
  }
`;
